import { render, staticRenderFns } from "./error-cms.vue?vue&type=template&id=4042f2c0&scoped=true"
import script from "./error-cms.vue?vue&type=script&lang=js"
export * from "./error-cms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042f2c0",
  null
  
)

export default component.exports